const data = {
    payType: [
        {
           type: 0,
           name: '现金'
        },
        {
            type: 1,
            name: '微信'
        },
        {
            type: 2,
            name: '支付宝',
        },
        {
            type: 3,
            name: '储值卡'
        },
        {
            type: 4,
            name: '经理签单'
        }
    ],
    sex: {
        1: '男',
        2: '女'
    }
}

const app = {
    state: {
        appMask: false,
        common_config: null
    },

    mutations: {
        getUrl (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [undefined, ""])[1].replace(/\+/g, '%20')) || null
        },
        SETAPPMASK: (state, value) => {
            state.appMask = value
        },
        SETCOMMONCONFIG: (state, value) => {
            if (value) {
                state.common_config = {...value, ...data}
            } else {
                state.common_config = null
            }
        }
    }
}

export default app
